import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, isRef as _isRef, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-field" }
const _hoisted_2 = { for: "hr_parent_sector" }
const _hoisted_3 = { class: "p-field" }
const _hoisted_4 = { for: "name" }

import { useCreateSector } from "./hooks/useCreateSector";
import SectorAutocomplete from "./SectorAutocomplete.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateSector',
  setup(__props) {

const { form, disableSubmit, loading, toggle, submit, visible } =
  useCreateSector();

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Button, {
      icon: "pi pi-plus",
      lable: _ctx.$t('new'),
      onClick: _unref(toggle)
    }, null, 8, ["lable", "onClick"]),
    _createVNode(_component_Dialog, {
      visible: _unref(visible),
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
      style: { width: '450px' },
      closable: true
    }, {
      header: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("new")), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: _ctx.$t('close'),
          icon: "pi pi-times",
          onClick: _unref(toggle),
          class: "p-button-warning"
        }, null, 8, ["label", "onClick"]),
        _createVNode(_component_Button, {
          loading: _unref(loading),
          disabled: _unref(disableSubmit),
          label: _ctx.$t('create0'),
          icon: "pi pi-save",
          "icon-pos": "right",
          onClick: _unref(submit)
        }, null, 8, ["loading", "disabled", "label", "onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("form", {
          autocomplete: "off",
          class: "p-fluid",
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_unref(submit) && _unref(submit)(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("hr_parent_sector")), 1),
            _createVNode(SectorAutocomplete, {
              id: "hr_parent_sector",
              modelValue: _unref(form).parentId.$value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).parentId.$value) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("activity.name")), 1),
            _createVNode(_component_InputText, {
              id: "name",
              modelValue: _unref(form).name.$value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).name.$value) = $event)),
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_unref(form).name.$validate())),
              class: _normalizeClass({ 'p-invalid': _unref(form).name.$hasError })
            }, null, 8, ["modelValue", "class"])
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})